import getWithToken from './base/get-with-token'

const getNotificationsRead = () => getWithToken(`/list-notifications-read`)()

export default getNotificationsRead